import styled from '@emotion/styled';

export const ShadowWrapper = styled.div<{ color: string }>`
  position: relative;
  ${({ theme, color }) => theme.media.showAt({ from: 3 })`
    --gradient: ${color || theme.colors.neutrals.grey11};
    :before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      background: var(--gradient);
      left: 100%;
      z-index: 1;
    }
    :after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      background: linear-gradient(90deg, var(--gradient) 0%, var(--gradient) calc(100% - 72px), transparent 100%);
      right: 100%;
      z-index: 1;
    }
  `}
`;
